







import Vue from 'vue'
import * as scroll from 'scroll'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ease = require('ease-component')

export default Vue.extend({
  name: 'PageTopButton',

  methods: {
    /**
     * ページトップに戻る
     */
    toPageTop () {
      const doc = document.scrollingElement ? document.scrollingElement : document.querySelector('html')
      scroll.top(doc as HTMLElement, 0, {
        duration: 350,
        ease: ease.outQuart,
      })
    },
  },
})
